__turbopack_context__.v({
  "notes": "Notes-module__H6wXSG__notes",
});
